import { Injectable } from '@angular/core';
import { ConfigurationService } from './common/configuration.service';
import { environment  } from "./../../environments/environment";

import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private baseHTTPUrl: string;
  selfcareproductsURL:string;
  operatorCode :number;

  constructor(private http : HttpClient, private config: ConfigurationService)
   { 
      this.baseHTTPUrl = config.baseHttpURL;
      this.operatorCode = config.OperatorCode;
      this.selfcareproductsURL =this.baseHTTPUrl + '/api/products?operatorid=' + this.operatorCode;
    
   }

   getAllProductsFromLte(){
    let url = `${environment.lteHttpBaseUrl}/api/products?operatorid=1`;
    return this.http.get<any>(url);
   }

   getSingleProductsFromLte(i_product:number){
    let url = `${environment.lteHttpBaseUrl}/api/products/${i_product}`;
    return this.http.get<any>(url);
   }
   
   getSelfcareProducts()
   {  
   
   
     return this.http.get<any>(this.selfcareproductsURL);  
   } 

}
